import classNames from "classnames";
import styles from "./BigButton.module.css";
import { useCallback, useEffect, useState } from "react";

interface BigButtonProps {
  title: string;
  style: "normal" | "disable" | "special" | "clear";
  hoverColor?: string;
  buttonNumber?: number;
  handleClick: (e?: React.MouseEvent<HTMLDivElement>) => void;
}

function BigButton(props: BigButtonProps) {
  const [mouseEvent, setMouseEvent] =
    useState<React.MouseEvent<HTMLDivElement>>();

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (
        props.buttonNumber !== undefined &&
        event.key === props.buttonNumber.toString()
      ) {
        props.handleClick(mouseEvent);
      }
    },
    [props.buttonNumber, props.handleClick]
  );

  // 컴포넌트 마운트 시 키 이벤트 리스너 추가, 언마운트 시 제거
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const buttonClass = classNames(styles.bigButton, {
    [styles.styleNormal]: props.style === "normal",
    [styles.styleDisable]: props.style === "disable",
    [styles.styleSpecial]: props.style === "special",
    [styles.styleClear]: props.style === "clear",
  });

  return (
    <>
      <div
        className={buttonClass}
        onClick={props.handleClick}
        onMouseEnter={(e) => {
          setMouseEvent(e);
          if (props.hoverColor === undefined) {
            return;
          }
          (e.currentTarget as HTMLDivElement).style.borderColor = "#FFFFFF";
          (e.currentTarget as HTMLDivElement).style.color = "#FFFFFF";
          (e.currentTarget as HTMLDivElement).style.backgroundColor =
            props.hoverColor || "";
        }}
        onMouseLeave={(e) => {
          if (props.hoverColor === undefined) {
            return;
          }
          (e.currentTarget as HTMLDivElement).style.borderColor = "";
          (e.currentTarget as HTMLDivElement).style.color = "";
          (e.currentTarget as HTMLDivElement).style.backgroundColor = "";
        }}
      >
        <div className={styles.leftContainer}>
          {props.buttonNumber !== undefined && (
            <span className={styles.leftNumber}>({props.buttonNumber})</span>
          )}
        </div>
        <p className={styles.title}>{props.title}</p>
        <div className={styles.rightContainer}></div>
      </div>
    </>
  );
}

export default BigButton;
